<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-一日三检记录-修改
    -->
    <el-dialog
    title="修改一日三检记录"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">修改一日三检记录</div>
      
        <el-form-item label="车牌号" prop="car_number">
          <el-input v-model="form.car_number" placeholder="请输入车牌号" class="max-w460"></el-input>
        </el-form-item>
        
        <el-form-item label="所属组织" prop="ma_company_id">
          <el-select 
            v-model="form.ma_company_id" 
            placeholder="请选择所属组织"
            style="width: 100%;"
            clearable
            filterable
            :loading="orgLoading"
          >
            <el-option label="请选择所属组织" value=""></el-option>
            <el-option
              v-for="dept in organizationList"
              :key="dept.ma_company_id"
              :label="dept.name"
              :value="dept.ma_company_id"
            />
          </el-select>
        </el-form-item>
        
        <el-form-item label="检查时间" prop="inspect_time">
          <div class="block">
            <el-date-picker
              size="small"
              v-model="form.inspect_time"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间"
            ></el-date-picker>
          </div>
        </el-form-item>
        
        <el-form-item label="检查人" prop="inspect_uid">
          <el-select
            v-model="form.inspect_uid"
            multiple
            placeholder="请选检查人"
            clearable
          >
            <el-option
              v-for="item in peopleList"
              :key="item.ma_yg_id"
              :label="`${item.name}(${item.organization_name || '无组织'})`"
              :value="String(item.ma_yg_id)"
            ></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="签名" prop="sign_img">
          <div class="d-s-c" style="flex-wrap: wrap;">
            <div v-if="form.sign_img" class="img-box">
              <img v-if="form.sign_img" :src="form.sign_img" class="product-img" width="100" height="100" />
              <div class="img-delete">
                <el-button type="text" size="small" @click="deleteSignImg">删除</el-button>
              </div>
            </div>
            <div v-if="!form.sign_img" class="d-c-c d-c p-0-10-0 upload-btn" @click="openSignUpload">
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <p>上传签名</p>
            </div>
          </div>
        </el-form-item>
        
        <el-form-item label="检查结果" prop="inspect_res">
          <el-select size="small" v-model="form.inspect_res">
            <el-option label="请选择" value=""></el-option>
            <el-option label="合格" :value="1"></el-option>
            <el-option label="不合格" :value="2"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="状态" prop="status">
          <el-select size="small" v-model="form.status">
            <el-option label="请选择" value=""></el-option>
            <el-option label="待排查" :value="0"></el-option>
            <el-option label="整改中" :value="1"></el-option>
            <el-option label="已完成" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核确认人" prop="review_uid">
          <el-select 
            v-model="form.review_uid" 
            placeholder="请选择审核确认人"
            style="width: 100%;"
            clearable
            filterable
          >
            <el-option
              v-for="person in peopleList"
              :key="person.ma_yg_id"
              :label="person.name"
              :value="person.ma_yg_id"
            />
          </el-select>
        </el-form-item>
        
        <el-form-item label="审核确认时间" prop="review_time">
          <div class="block">
            <el-date-picker
              size="small"
              v-model="form.review_time"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间"
            ></el-date-picker>
          </div>
        </el-form-item>
        
        <el-form-item label="整改确认人" prop="rectificat_uid">
          <el-select 
            v-model="form.rectificat_uid" 
            placeholder="请选择整改确认人"
            style="width: 100%;"
            clearable
            filterable
          >
            <!-- 修复：整改确认人应该用人员列表而不是组织列表 -->
            <el-option
              v-for="person in peopleList"
              :key="person.ma_employee_id"
              :label="person.name"
              :value="person.ma_employee_id"
            />
          </el-select>
        </el-form-item>
        
        <el-form-item label="整改确定时间" prop="rectificat_time">
          <div class="block">
            <el-date-picker
              size="small"
              v-model="form.rectificat_time"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间"
            ></el-date-picker>
          </div>
        </el-form-item>
        
        <el-form-item label="排序" prop="sort">
          <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
        </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    
    <!--签名图片组件-->
    <Upload v-if="isSignUpload" :config="{ total: 1 }" :isupload="isSignUpload" @returnImgs="returnSignImgsFunc">
      上传签名
    </Upload>
    <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
  </div>
</el-dialog>
  
</template>

<script>
import AfuncApi from '@/api/afunc.js';
import Inspection_threeApi from '@/api/inspection_three.js';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {
     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter
  },
  data() {
    return {
      peopleList: [],
      organizationList: [],
      orgLoading: false,
      /*是否上传图片*/
      isupload: false,
      isImg: false,
      isSignUpload: false,
          /*富文本配置*/
          ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        ma_company_id: '',
        car_number: '',
        inspect_time: '',
        inspect_uid: [],
        sign_img: '',
        inspect_res: '',
        status: '',
        review_uid: '',
        review_time: '',
        rectificat_uid: '',
        rectificat_time: '',
        sort: '',
        image: [],
        bannar: []
      },
      loading: false,
      rules: {
        car_number: [{ required: true, message: '请输入车牌号', trigger: 'blur' }], 
        ma_company_id: [{ required: true, message: '请选择所属组织', trigger: 'change' }],
        inspect_time: [{ required: true, message: '请选择检查时间', trigger: 'change' }],
        inspect_uid: [{ 
          required: true, 
          message: '请选择检查人', 
          trigger: 'change',
          type: 'array' 
        }],
        sign_img: [{ required: true, message: '请输入签名', trigger: 'blur' }],
        inspect_res: [{ required: true, message: '请选择检查结果', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
        review_uid: [{ required: true, message: '请选择审核确认人', trigger: 'change' }],
        review_time: [{ required: true, message: '请选择审核确认时间', trigger: 'change' }],
        rectificat_uid: [{ required: true, message: '请选择整改确认人', trigger: 'change' }],
        rectificat_time: [{ 
          required: true, 
          message: '请选择整改确认时间', 
          trigger: 'change' 
        }], 
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }] 
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
         code:"album"
    };
  },
  created() {
    this.loadOrganization();
    this.loadPeopleList();
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add","inspection_three_id"],
  methods: {
     async loadPeopleList() {
      try {
        const response = await AfuncApi.call({
          model: 'ma_yg',
          action: 'getList',
        });
        if (!response) {
          this.$message.warning('人员列表接口返回为空');
          this.peopleList = [];
          return;
        }
        
        if (response.code === 1 && response.data && response.data.list) {
          this.peopleList = response.data.list.data || [];
        } else {
          this.$message.warning('获取人员列表失败：' + (response.msg || '未知错误'));
          this.peopleList = [];
        }
      } catch (error) {
        console.error('加载人员列表失败:', error);
        this.$message.error('加载人员列表失败，请稍后重试');
        this.peopleList = []; // 确保数组有初始值
      }
    },
    
    // 加载组织列表 - 修复空值判断
    async loadOrganization() {
      this.orgLoading = true;
      try {
        const response = await AfuncApi.call({
          model: 'ma_company',
          action: 'getList',
          page: 1,
          list_rows: 1000
        });
        
        if (response.code === 1 && response.data && response.data.list) {
          this.organizationList = response.data.list.data || [];
        } else {
          this.$message.warning('获取组织列表失败：' + (response.msg || '未知错误'));
          this.organizationList = [];
        }
      } catch (error) {
        console.error('加载组织列表失败:', error);
        this.$message.error('加载组织列表失败，请稍后重试');
        this.organizationList = []; // 确保数组有初始值
      } finally {
        this.orgLoading = false;
      }
    },
    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },

     /*获取图片*/
     returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
          this.form.image = e[0].file_path;
          this.isImg = true;
        
      }
      this.isupload = false;
    },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    getDetail() {
      let self = this;
      Inspection_threeApi.detail({inspection_three_id: self.inspection_three_id},true).then(res => {
          self.form = res.data;
          self.isImg = true
          self.loading = false;
          if(!self.form.bannar){
            self.form.bannar = [];
          }
          if(!self.form.image){
            self.form.image = [];
          }
          if (self.form.inspect_uid) {
            if (typeof self.form.inspect_uid === 'string') {
              self.form.inspect_uid = self.form.inspect_uid.split(',').map(id => String(id));
            } else if (Array.isArray(self.form.inspect_uid)) {
              self.form.inspect_uid = self.form.inspect_uid.map(id => String(id));
            }
          }
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;
      form.inspection_three_id = self.inspection_three_id;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Inspection_threeApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },
    
    // 打开签名上传
    openSignUpload() {
      this.isSignUpload = true;
    },
    
    // 删除签名
    deleteSignImg() {
      this.form.sign_img = '';
    },
  
    /*上传业务附件*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },
    
    // 处理签名上传返回
    returnSignImgsFunc(e) {
      if (!e || e.length === 0) {
        this.isSignUpload = false;
        return;
      }
      
      // 验证图片格式
      const imgExts = ["bmp", "jpg", "jpeg", "png", "gif"];
      const isValid = e.every(element => {
        const ext = element.file_path.split(".").pop().toLowerCase();
        return imgExts.includes(ext);
      });
      
      if (!isValid) {
        this.$message.error("图片类型有误，请选择 bmp、jpg、jpeg、png、gif 格式的图片");
        this.isSignUpload = false;
        return;
      }
      
      // 设置签名图片（只取第一张）
      this.form.sign_img = e[0].file_path;
      this.isSignUpload = false;
    },

    /*删除业务附件*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}



.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.img-box {
  position: relative;
  display: inline-block;
  margin-right: 10px;
}

.img-box img {
  border: 1px solid #ddd;
  border-radius: 4px;
}

.img-delete {
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 2px 8px;
  border-radius: 0 4px 0 4px;
  cursor: pointer;
}

.upload-btn {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #8c939d;
  background: #fafafa;
}

.upload-btn:hover {
  border-color: #409eff;
  color: #409eff;
}

.upload-btn i {
  font-size: 28px;
  margin-bottom: 8px;
}

.upload-btn p {
  margin: 0;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/inspection_three/index/part/edit.vue